__turbopack_context__.v({
  "flexContent": "az5BIW_flexContent",
  "wrapper": "az5BIW_wrapper",
});
